import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryBilling } from './api';

export interface WalletBalanceResponse {
  wallet_id: string;
  balance: number;
  reserved: number;
  available: number;
}

export interface WalletTransactionResponse {
  id: string;
  operation_date: string;
  type: number;
  amount: string;
  source_type: string;
  description: string;
  balance_after: string;
}

export interface WalletTransactionsResponse {
  wallet_id: string;
  transactions: WalletTransactionResponse[];
}

export const walletApi = createApi({
  reducerPath: 'wallet',
  baseQuery: baseQueryBilling,
  endpoints: (builder) => ({
    getWalletBalance: builder.query<WalletBalanceResponse, void>({
      query: () => ({
        url: '/wallet/balance',
        method: 'GET',
      }),
    }),
    getWalletTransactions: builder.query<WalletTransactionsResponse, void>({
      query: () => ({
        url: '/wallet/transactions',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetWalletBalanceQuery,
  useLazyGetWalletBalanceQuery,
  useGetWalletTransactionsQuery,
  useLazyGetWalletTransactionsQuery,
} = walletApi;
